module.exports = __webpack_public_path__ + "img/bj.fe5a8666.png";